import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-capabilities',
	templateUrl:'./CapabilitiesPage.html',
	styles: [],
	styleUrls:['./CapabilitiesPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
],
	standalone:true
})
export class CapabilitiesPage
{
}
